<template>
  <div id="app" :class="`ic-product-${activeProduct}`">
    <router-view />
    <toast />

    <div v-if="isLoading" class="ic-global__loading" data-grid="center-center">
      <loading />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'App',
  computed: {
    ...mapGetters({
      isLoading: 'getLoading'
    }),
  
    activeProduct() {
      var product = this.$route.query.partner ? 'checkout' : (this.$route.query.product || 'global')
      return product;
    },
  },

  async mounted() {
    await this.auth();
  },

  methods: {
    ...mapActions(['auth'])
  },

  watch: {
    $user: {
      deep: true,
      async handler(user) {
        const { $router } = this;

        if (user === null || Object.keys(user || {}).length <= 0) {
          $router.push({ name: "auth-login", query: { ...window.$route.query } });
        } else if (window.$route.name === "auth-login") {
          $router.push({ name: 'products', query: { ...window.$route.query } })
        }
      },
    },
  }
}
</script>

<style lang="sass">
@import '@/components/sass/global'

*
  margin: 0
  padding: 0

input, select
  &:focus
    outline: none

a, button 
  cursor: pointer

#app
  font-family: 'Nunito', sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale

.ic-global__loading
  position: fixed
  width: 100%
  height: 100%
  top: 0
  left: 0
  z-index: 999999999

  &:before
    content: ''
    width: 100%
    height: 100%
    position: fixed
    z-index: 0
    background: rgb(0 0 0 / 45%)
    backdrop-filter: blur( 10px )
    -webkit-backdrop-filter: blur( 13.5px )
</style>

